import { AgGridColumnProps } from "ag-grid-react";
import { asCurrency, asTimelessDateUTC } from "lqx-react/src";
import { getCellColor, getAssetStatus, getAssetErrors } from "../components/assets-table";

export enum FilterName {
    Payor = 'payors',
    PayorBankName = 'payorBankNames',
    PayorBankAlias = 'payorBankAliases',
    PayorBankAccountNumber = 'payorBankAccountNumbers',
    PayorBankAddress = 'payorBankAddresse',
    Payee = 'payees',
    PayeeBankName = 'payeeBankNames',
    PayeeBankAlias = 'payeeBankAliases',
    PayeeBankAccountNumber = 'payeeBankAccountNumbers',
    PayeeBankAccountAddress = 'payeeBankAccountAddresse',
    PaymentType = 'paymentTypes',
    ReferenceNumber = 'referenceNumbers',
    PaymentAmount = 'paymentAmounts',
    Currency = 'currencies',
    ValueDate = 'valueDates',
    OriginalAssetObligor = 'originalAssetObligors'
}

export enum FilterTypePayments {
    All = 0,
    ValidationCategory,
    AssetState,
    Payor,
    PayorBankName,
    PayorBankAlias,
    PayorBankAccountNumber,
    PayorBankAddress,
    Payee,
    PayeeBankName,
    PayeeBankAlias,
    PayeeBankAccountNumber,
    PayeeBankAccountAddress,
    PaymentType,
    ReferenceNumber,
    PaymentAmount,
    Currency,
    ValueDate,
    OriginalAssetObligor
}

export enum PaymentsSortingBase {
    Id = 0,
    CreatedOn,
    UpdatedOn,
    ValidationCategory,
    AssetState,
    Payor,
    PayorBankName,
    PayorBankAlias,
    PayorBankAccountNumber,
    PayorBankAddress,
    Payee,
    PayeeBankName,
    PayeeBankAlias,
    PayeeBankAccountNumber,
    PayeeBankAccountAddress,
    PaymentType,
    ReferenceNumber,
    PaymentAmount,
    Currency,
    ValueDate,
    OriginalAssetObligor,
    PaymentDetails,
    LockBoxNumber,
    PaymentMethod,
    BankEntryDate
}

export enum PaymentsTableColumns {
    Status = 0,
    Payor,
    PayorBankName,
    PayorBankAlias,
    PayorBankAccountNumber,
    PayorBankAddress,
    Payee,
    PayeeBankName,
    PayeeBankAlias,
    PayeeBankAccountNumber,
    PayeeBankAccountAddress,
    PaymentType,
    ReferenceNumber,
    PaymentAmount,
    Currency,
    ValueDate,
    OriginalAssetObligor,
    Errors,
    PaymentDetails,
    LockBoxNumber,
    PaymentMethod,
    BankEntryDate
}

export const PaymentTableColumns: AgGridColumnProps[] = [
    {
        colId: 'CheckBox',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true
    },
    {
        colId: PaymentsTableColumns.Status.toString(),
        headerName: "Status",
        filter: 'agSetColumnFilter',
        filterParams: {
            values: ['Pass Validation - New', 'Pass Validation - Modified', 'Require Review', 'Duplicated', 'Conflict', 'Saved for Later', 'Digitized', 'Modifies Existing']
        },
        valueGetter: params => getAssetStatus(params.data),
        cellStyle: params => { return { color: getCellColor(params.data) } },
        sortable: true
    }, {
        colId: PaymentsTableColumns.Errors.toString(),
        headerName: "Errors",
        valueGetter: params => getAssetErrors(params.data)
    }, {
        colId: PaymentsTableColumns.Payor.toString(),
        headerName: "Payor",
        field: "changes.debtorBankAccount.payor.name",
        filter: 'agSetColumnFilter',
        filterParams: {
            values: ['Pass Validation - New', 'Pass Validation - Modified', 'Require Review', 'Duplicated', 'Conflict', 'Saved for Later', 'Digitized', 'Modifies Existing']
        },
        sortable: true

    }, {
        colId: PaymentsTableColumns.PayorBankName.toString(),
        headerName: "Payor Bank Name",
        field: "changes.debtorBankAccount.name",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.PayorBankAlias.toString(),
        headerName: "Payor Bank Alias",
        field: "changes.debtorBankAccount.alias",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.PayorBankAccountNumber.toString(),
        headerName: "Payor Bank Account Number",
        field: "changes.debtorBankAccount.number",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.PayorBankAddress.toString(),
        headerName: "Payor Bank Address",
        field: "changes.debtorBankAccount.address",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.Payee.toString(),
        headerName: "Payee",
        field: "changes.creditorBankAccount.payee.name",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.PayeeBankName.toString(),
        headerName: "Payee Bank Name",
        field: "changes.creditorBankAccount.name",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.PayeeBankAlias.toString(),
        headerName: "Payee Bank Alias",
        field: "changes.creditorBankAccount.alias",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.PayeeBankAccountNumber.toString(),
        headerName: "Payee Bank Account Number",
        field: "changes.creditorBankAccount.number",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.PayeeBankAccountAddress.toString(),
        headerName: "Payee Bank Account Address",
        field: "changes.creditorBankAccount.address",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.PaymentType.toString(),
        headerName: "Payment Type",
        field: "changes.paymentType.name",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.ReferenceNumber.toString(),
        headerName: "Reference Number",
        field: "changes.referenceNumber",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.PaymentAmount.toString(),
        headerName: "Payment Amount",
        field: "changes.paymentAmount",
        cellStyle: { textAlign: "right" },
        valueFormatter: asCurrency,
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.Currency.toString(),
        headerName: "Currency",
        field: "changes.currency",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.ValueDate.toString(),
        headerName: "Value Date",
        field: "changes.assetPaymentDate",
        valueFormatter: asTimelessDateUTC,
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.OriginalAssetObligor.toString(),
        headerName: "Original Asset Obligator",
        field: "changes.originalAssetObligor.name",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.PaymentDetails.toString(),
        headerName: "Payment Details",
        field: "changes.paymentDetails",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.LockBoxNumber.toString(),
        headerName: "Lock Box Number",
        field: "changes.lockBoxNumber",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.PaymentMethod.toString(),
        headerName: "Payment Method",
        field: "changes.paymentMethod.name",
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }, {
        colId: PaymentsTableColumns.BankEntryDate.toString(),
        headerName: "Bank Entry Date",
        field: "changes.bankEntryDate",
        valueFormatter: asTimelessDateUTC,
        filter: 'agTextColumnFilter',
        filterParams: {
            filterOptions: ['contains'],
            suppressAndOrCondition: true
        },
        sortable: true
    }
]
